import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form/dist/index.ie11';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { CustomLabelWithTooltip } from 'src/components/common/CustomLabelWithTooltip/CustomLabelWithTooltip';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';
import { ConfirmPasswordRestriction } from 'src/components/enterprise/features/Corporate/components/Form/SSOWrapper/PasswordRestrictedControl/ConfirmPasswordRestriction';
import { usePasswordRestrictConfirmation } from 'src/components/enterprise/features/Corporate/components/Form/SSOWrapper/PasswordRestrictedControl/hooks/usePasswordRestrictConfirmation';

export interface PasswordRestrictControlProps {
  name: string;
  id: string;
  disabled: boolean;
}

type WatchPasswordType = {
  [key: string]: boolean;
};

export function PasswordRestrictControl({
  name,
  id,
  disabled,
}: PasswordRestrictControlProps): JSX.Element {
  const { control } = useFormContext();
  const {
    confirmationModalOpen,
    setFieldValue,
    onChangeCheckedFeature,
    closeConfirmationModal,
  } = usePasswordRestrictConfirmation(name);

  const watchedValues = useWatch<WatchPasswordType>({
    name: [name],
  });
  const passwordRestrictEnabled = watchedValues?.[name];

  return (
    <>
      <CookbookCheckboxWrapper
        control={control}
        id={id}
        name={name}
        disabled={disabled}
        label={
          <CustomLabelWithTooltip
            color="primaryText"
            labelText="Restrict diners to SSO log in only"
            tooltipInfo={
              passwordRestrictEnabled ? (
                <Copy variant="body" color="invertedPrimaryText">
                  Opt out is available only after the request to engineering.
                </Copy>
              ) : (
                <Copy variant="body" color="invertedPrimaryText">
                  Diners will not be able to log using a standard password. They
                  must login via their SSO identify provider
                </Copy>
              )
            }
          />
        }
        onChange={onChangeCheckedFeature}
      />
      {confirmationModalOpen && (
        <ConfirmPasswordRestriction
          onConfirm={setFieldValue}
          onClose={closeConfirmationModal}
        />
      )}
    </>
  );
}
